import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';

export const UpsellStyled = styled.div.attrs({
  className: 'addon-screen',
})`
  ${({ theme }) => {
    const { colors, media } = theme;
    return css`
      background-color: ${colors.primary.white};
      color: border: ${colors.primary.dark};
      box-shadow: 0 20px 40px 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      width: 80vw;
      max-width: 1280px;
      height: 99vh;
      max-height: 900px;
      overflow-x: hidden;

      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 2% 6%;
      border-radius: 32px;
      position: relative;

      ${media.tablet.only} {
        width: 96vw;
      }

      ${media.mobile.down} {
        width: 90vw;
        padding: 10% 8%;
      }

      .icon--fill-close-thin {
        fill: ${colors.secondary.gray};
        height: 16px;
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        cursor: pointer;
      }

      .addon-screen {
        &__header {
          display: flex;
          flex-direction: column;
          align-items: center;

          h3 {
            color: ${theme.colors.primary.darkBlue};
            font-weight: 700;
            font-size: 42px;
            margin-top: 32px;

            ${media.mobile.down} {
              font-size: 24px;
            }
          }

          &-description {
            margin-top: 32px;
            text-align: center;
            font-weight: 400;
            font-size: 24px;
            line-height: 28px;
            max-width: 600px;

            ${media.mobile.down} {
              font-size: 16px;
            }
          }
        }

        &__container {
          font-weight: 700;
          line-height: 20px;
          color: ${theme.colors.primary.darkBlue};
        }

        &__description {
          text-align: center;
          font-weight: 700;
          font-size: 30px;
          line-height: 38px;
          padding: 16px 0;

          ${media.mobile.down} {
            font-size: 16px;
            padding: 16px 0 5px;;
          }
        }

        &__Products {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 15px;

          &__bullet {
            padding-right: 4px;
            margin-top: 5px;

            svg {
              height: 12px;
            }
          }

          ${media.tablet.down} {
            padding-bottom: 8px;
          }
        }

        &__bottomDescriptionContainer {
          display: flex;
          justify-content: center;
          padding: 16px 0;

          ${media.mobile.down} {
            align-items: center;
            flex-direction: column;
          }
        }

        &__bottomDescription {
          padding: 5px 0;
          font-weight: 400;
          font-size: 24px;
          line-height: 28px;

          ${media.mobile.down} {
            width: 100%;
            text-align: center;
          }

          &-price {
            margin-left: 16px;
            display: flex;

            &-dollarSign{
              font-weight: 700;
              font-size: 26.53px;
              line-height: 30.95px;

            }

            &-amount {
              font-weight: 700;
              font-size: 46.42px;
              line-height: 50.84px;
            }

            &-cents {
              font-weight: 500;
              font-size: 13.26px;
              line-height: 17.68px;
            }

            &-strike{
              padding-left: 15px;
              text-decoration: line-through;
              text-decoration-color: ${colors.primary.red};
            }

            &-text {
              margin-left: 5px;
              font-weight: 400;
              font-size: 12.83px;
              line-height: 17.96px;
            }

          }

        }
      }

      .duplicateAddOn__ctaContainer {
        display: flex;
        justify-content: space-between;
        width: 600px;

        ${media.mobile.down} {
          flex-direction: column;
          max-width: 300px;
        }
      }

      .duplicateAddOn__ctaReplace {
        background-color: ${colors.primary.red};
        border-color: ${colors.primary.white};
        color: ${colors.primary.white}
      }

      .duplicateAddOn__ctaCancel{
        ${media.mobile.down} {
          margin-top: 16px;
        }
      }
        }
      }
    `;
  }}
`;
